import ICommonFieldData from './ICommonFieldData';

export default {
    duplicate(fieldDatas: Array<ICommonFieldData>): Array<ICommonFieldData> {
        const result: Array<ICommonFieldData> = [];
        if (fieldDatas && fieldDatas.length > 0) {
            for (const fieldData of fieldDatas) {
                const resultFieldData: ICommonFieldData = {
                    fieldName: fieldData.fieldName,
                    value: fieldData.value
                };
                result.push(resultFieldData);
            }
        }

        return result;
    }
};
